// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DarkTheme__env-button___d9enZ {
    background-color: var(--steel2);
    border-color: var(--steel2);
    box-shadow: none;
    color: var(--aluminum3);
    fill: currentColor;
  }

    .DarkTheme__env-button___d9enZ:hover {
      background-color: var(--steel5);
      border-color: var(--steel5);
      color: var(--aluminum3);
    }

    .DarkTheme__env-button___d9enZ:active {
      color: var(--primary);
    }
  .DarkTheme__env-item___tJrec:hover {
      background-color: var(--steel3);
    }
  .DarkTheme__env-item___tJrec:active, .DarkTheme__env-item___tJrec.DarkTheme__active___3-4tT {
      background-color: var(--steel4);
    }
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/platform-components/EnvSwitcher/themes/DarkTheme.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;EACpB;;IAEE;MACE,+BAA+B;MAC/B,2BAA2B;MAC3B,uBAAuB;IACzB;;IAEA;MACE,qBAAqB;IACvB;EACF;MACI,+BAA+B;IACjC;EACF;MACI,+BAA+B;IACjC","sourcesContent":[".DarkTheme__env-button___d9enZ {\n    background-color: var(--steel2);\n    border-color: var(--steel2);\n    box-shadow: none;\n    color: var(--aluminum3);\n    fill: currentColor;\n  }\n\n    .DarkTheme__env-button___d9enZ:hover {\n      background-color: var(--steel5);\n      border-color: var(--steel5);\n      color: var(--aluminum3);\n    }\n\n    .DarkTheme__env-button___d9enZ:active {\n      color: var(--primary);\n    }\n  .DarkTheme__env-item___tJrec:hover {\n      background-color: var(--steel3);\n    }\n  .DarkTheme__env-item___tJrec:active, .DarkTheme__env-item___tJrec.DarkTheme__active___3-4tT {\n      background-color: var(--steel4);\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
